import { FilterItem } from '../filters';

export enum MediaRecordType {
  INACTIVE = 'inactive',
  POPULAR = 'popular',
  MINIMUM = 'minimum',
  MAXIMUM = 'maximum',
  OTHER = 'other',
}

export const MEDIA_RECORD_TYPE_MAP = {
  [MediaRecordType.INACTIVE]: 'Неактивная',
  [MediaRecordType.POPULAR]: 'Популярная',
  [MediaRecordType.MINIMUM]: 'Минимальная',
  [MediaRecordType.MAXIMUM]: 'Максимальная',
  [MediaRecordType.OTHER]: 'Прочее'  
};

export const MEDIA_RECORD_TYPE_ARRAY: FilterItem<string>[] = Object.values(MediaRecordType).map((mediaRecordTypes) => ({ id: mediaRecordTypes, label: MEDIA_RECORD_TYPE_MAP[mediaRecordTypes] }));
